"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareCorpus = prepareCorpus;
exports.selectNItems = selectNItems;
exports.prepareMultiBlockCat = prepareMultiBlockCat;
exports.updateTheta = updateTheta;
const shuffle_1 = __importDefault(require("lodash/shuffle"));
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
const taskSetup_2 = require("../../taskSetup");
// separates trials from corpus into blocks depending on for heavy/light instructions and CAT
function prepareCorpus(corpus, randomStartBlock = true, downexCorpus, fillInSdsDifficulty = false) {
    const excludedTrialTypes = ['3D', 'polygon'];
    // limit random starting items so that their difficulty is less than 0
    const maxTrialDifficulty = 0;
    const cat = (0, taskStore_1.taskStore)().runCat;
    let corpora;
    let heavyInstructionPracticeTrials = [];
    let downexTestTrials = [];
    if (downexCorpus) {
        heavyInstructionPracticeTrials = downexCorpus.filter((trial) => trial.trialType === 'instructions' || trial.assessmentStage === 'practice_response');
        downexTestTrials = downexCorpus.filter((trial) => !heavyInstructionPracticeTrials.includes(trial));
    }
    const lightInstructionPracticeTrials = corpus.filter((trial) => trial.trialType === 'instructions' || trial.assessmentStage === 'practice_response');
    const testTrials = corpus.filter((trial) => !lightInstructionPracticeTrials.includes(trial));
    const corpusParts = {
        ipHeavy: heavyInstructionPracticeTrials,
        ipLight: lightInstructionPracticeTrials,
        test: testTrials,
        downexTest: downexTestTrials,
    };
    // something same 1 trials inherit difficulty from the corresponding something same 2 trial
    if (fillInSdsDifficulty) {
        corpusParts.test.forEach((trial, index) => {
            if (trial.trialType === 'something-same-1') {
                const nextTrial = corpusParts.test[index + 1];
                if (nextTrial.trialType === 'something-same-2') {
                    trial.difficulty = nextTrial.difficulty;
                }
            }
        });
    }
    // separate out normed/unnormed trials
    const unnormedTrials = corpusParts.test.filter((trial) => trial.difficulty == null || isNaN(Number(trial.difficulty)));
    const normedTrials = corpusParts.test.filter((trial) => !unnormedTrials.includes(trial));
    // determine start items
    const possibleStartItems = normedTrials.filter((trial) => !excludedTrialTypes.includes(trial.trialType) &&
        (((0, taskStore_1.taskStore)().task == 'egma-math' && trial.block_index === 0) || (0, taskStore_1.taskStore)().task !== 'egma-math') &&
        Number(trial.difficulty) <= maxTrialDifficulty);
    const startItems = selectNItems(possibleStartItems, 5);
    // put cat portion of corpus into taskStore
    const catCorpus = randomStartBlock
        ? normedTrials.filter((trial) => !startItems.includes(trial))
        : normedTrials;
    const downexUnnormedTrials = downexTestTrials.filter((trial) => trial.difficulty == null || isNaN(Number(trial.difficulty)));
    const downexCatCorpus = downexTestTrials.filter((trial) => !downexUnnormedTrials.includes(trial));
    corpora = {
        ipHeavy: corpusParts.ipHeavy, // downex instruction/practice trials
        ipLight: corpusParts.ipLight, // older kid instruction/practice
        start: startItems, // 5 random items to be used in starting block (all under a certain max difficulty)
        unnormed: unnormedTrials, // all items without IRT parameters
        downexUnnormed: downexUnnormedTrials,
        cat: catCorpus, // all normed items for CAT
        downexCat: downexCatCorpus,
    };
    if (cat) {
        // if cat is running, put only normed trials into taskStore
        const newCorpora = {
            downex: downexTestTrials,
            stimulus: catCorpus,
        };
        (0, taskStore_1.taskStore)('corpora', newCorpora);
    }
    else {
        // if cat is not running, put entire test portion of corpus into taskStore but leave out instruction/practice
        const newCorpora = {
            practice: downexTestTrials,
            stimulus: corpusParts.test,
        };
        (0, taskStore_1.taskStore)('corpora', newCorpora);
    }
    return corpora;
}
function selectNItems(corpus, n) {
    const finalTrials = [];
    // randomize order of items
    const shuffledTrials = (0, shuffle_1.default)(corpus);
    // get the last n items
    for (let i = n; i > 0; i--) {
        const trial = shuffledTrials.pop();
        if (trial !== undefined) {
            finalTrials.push(trial);
        }
    }
    return finalTrials;
}
// separates cat corpus into blocks
function prepareMultiBlockCat(corpus, sequentialBlocks = true) {
    const blockList = []; // a list of blocks, each containing trials
    if (sequentialBlocks) {
        // sort by block index before batching
        corpus.sort((a, b) => {
            return Number(a.block_index) - Number(b.block_index);
        });
    }
    let currBlock = -1; // start at -1 so it is guaranteed to be less than first block
    corpus.forEach((trial) => {
        const prevBlock = currBlock;
        currBlock = Number(trial.block_index);
        if (currBlock != undefined) {
            if (currBlock !== prevBlock) {
                blockList.push([trial]);
            }
            else {
                blockList[blockList.length - 1].push(trial);
            }
        }
    });
    return blockList;
}
function updateTheta(item, correct) {
    const runCat = (0, taskStore_1.taskStore)().runCat;
    if (runCat) {
        // update theta for CAT
        const zeta = {
            a: 1, // item discrimination (default value of 1)
            b: item.difficulty, // item difficulty (from corpus)
            c: item.chanceLevel, // probability of correct answer from guessing
            d: 1, // max probability of correct response (default 1)
        };
        if (!Number.isNaN(zeta.b) && zeta.b !== null && item.assessmentStage !== 'practice_response') {
            const answer = correct ? 1 : 0;
            taskSetup_1.cat.updateAbilityEstimate(zeta, answer);
        }
    }
    taskSetup_2.jsPsych.data.addDataToLastTrial({
        thetaEstimate: taskSetup_1.cat.theta,
    });
}
